module.exports = __webpack_public_path__ + "a0e677214200a3a9be595dbf9c75cacb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-toucan.png
// module id = 1276
// module chunks = 0